import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { errorCatch, GET, useAuth, useUserContext } from 'fennec-ui';
import { isAnyFederationAdministrator, isMyEvent } from '../../../../common/Tool';
import AvatarEditor from '../../../components/AvatarEditor';


export default function ByIDAvatar(props) {
    let { id } = useParams();
    const auth = useAuth();
    const user = useUserContext();

    const [event, setEvent] = useState(undefined);
    useEffect(() => {
        GET(auth, `/api/meropriyatiya/list/com?detail=model&w-id=${id}`,
            ({ data }) => {
                if (data && data.length) {
                    setEvent(data[0]);
                }
            }, errorCatch);
    }, [])
    const admin = (event && user) ? (isMyEvent(event, user, false) || isAnyFederationAdministrator(user)): false;
    return (
        <div>
            {event &&
                <AvatarEditor event={event} admin={admin} />
            }
        </div>
    );
}
